import React from "react";

const RotateRight = ({ style = {}, size = "18", className = "", fill = "#73788B", viewBox = "0 0 24 24" }) => (
    <svg 
    width={size}
    style={style}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
            className="u_fill-stroke"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M23 4v6h-6"
        />
        <path
            className="u_fill-stroke"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
        />
    </svg>
);

export default RotateRight;
